module.exports = __webpack_public_path__ + "static/media/gryphon-house-east-view-closeup.900857dd.jpg";